import React, { useMemo } from 'react';
import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { Link } from 'react-router-dom';
import { lightGrey, lightTeal } from '../../../mainTheme';

interface SidebarMenuItemProps {
  icon: React.ReactElement<SvgIconProps>;
  text: string;
  to: string;
  open: boolean;
  selected: boolean;
  selectedIcon?: React.ReactElement<SvgIconProps>;
}

const SidebarMenuItem: React.FC<SidebarMenuItemProps> = ({
  icon,
  text,
  to,
  open,
  selected,
  selectedIcon,
}) => {
  const clonedIcon = useMemo(() => {
    return React.isValidElement(icon)
      ? React.cloneElement(icon, {
          style: { fill: selected ? lightTeal : lightGrey },
        })
      : icon;
  }, [icon, selected]);

  return (
    <ListItem
      button
      component={Link}
      to={to}
      sx={{
        borderRadius: '10px',
        border: selected ? '1px solid var(--color-gray-medium, #865E9C)' : null,
        backgroundColor: selected ? '#F6F2F7' : null,
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
      }}
    >
      <Box display="flex">
        <Box display="flex" alignItems="center" minWidth={40}>
          <ListItemIcon
            sx={{
              color: selected ? lightTeal : lightGrey,
              minWidth: 'auto',
              width: 24,
              height: 24,
            }}
          >
            {selected && selectedIcon ? selectedIcon : clonedIcon}
          </ListItemIcon>
        </Box>
        <Box>
          {open && (
            <ListItemText
              primary={
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: selected ? '700' : '500',
                    color: selected ? '#2A2A30' : '#585863',
                    lineHeight: '22px',
                    letterSpacing: '0.2px',
                  }}
                >
                  {text}
                </Typography>
              }
            />
          )}
        </Box>
      </Box>
    </ListItem>
  );
};

export default SidebarMenuItem;
